import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const upload = (uploadData: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claimBatchReports.isUploading) { return Promise.reject(); }

  dispatch({ type: types.UPLOAD_BATCH_CLAIM_TEST_FILE_REQUEST });

  return api.claim.batchReports.upload(uploadData)
    .then((res: any) => {

      dispatch({
        type: types.UPLOAD_BATCH_CLAIM_TEST_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPLOAD_BATCH_CLAIM_TEST_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const uploadBatchClaimFiles = (uploadData: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claimBatchReports.isUploading) { return Promise.reject(); }

  dispatch({ type: types.UPLOAD_BATCH_CLAIM_FILES_REQUEST });

  return api.claim.batchReports.uploadBatchClaimFiles(uploadData)
    .then((res: any) => {

      dispatch({
        type: types.UPLOAD_BATCH_CLAIM_FILES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPLOAD_BATCH_CLAIM_FILES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSubmitted = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SUBMITTED_BATCH_REPORTS_REQUEST });

  return api.claim.batchReports.getSubmitted(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_SUBMITTED_BATCH_REPORTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SUBMITTED_BATCH_REPORTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSubmittedUsingEdifecs = (searchObject: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SUBMITTED_BATCH_REPORTS_REQUEST });

  return api.claim.batchReports.getSubmittedUsingEdifecs(searchObject)
    .then((res: any) => {

      dispatch({
        type: types.GET_SUBMITTED_BATCH_REPORTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SUBMITTED_BATCH_REPORTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getTestHistory = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_BATCH_TEST_HISTORY_REQUEST });

  return api.claim.batchReports.getTestHistory(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_BATCH_TEST_HISTORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_BATCH_TEST_HISTORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getAllTestHistory = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_ALL_CLAIM_BATCH_TEST_HISTORY_REQUEST });

  return api.claim.batchReports.getAllTestHistory(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_CLAIM_BATCH_TEST_HISTORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_CLAIM_BATCH_TEST_HISTORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const insertHeader = (claimSubmission: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claimBatchReports.isInserting) { return Promise.reject(); }

  dispatch({ type: types.INSERT_CLAIM_BATCH_HEADER_REQUEST });

  return api.claim.batchReports.insertHeader(claimSubmission)
    .then((res: any) => {

      dispatch({
        type: types.INSERT_CLAIM_BATCH_HEADER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.INSERT_CLAIM_BATCH_HEADER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  